var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterHorse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 432,
    viewBox: "0 0 671 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.664 115.873C617.789 105.238 593.363 75.4076 585.047 68.4039C585.177 67.8851 583.228 64.7723 582.319 63.6051C581.149 62.0487 580.37 60.3626 579.85 58.6765C576.602 54.1371 576.342 46.7443 575.303 40C570.105 43.8909 565.948 51.5431 564.519 58.9359C565.948 59.0656 564.259 59.1953 564.389 59.1953C564.389 59.0656 564.389 58.9359 564.519 58.9359C562.7 58.8062 560.491 58.5468 559.062 58.4171C559.062 58.2874 559.062 58.2874 559.062 58.1577C527.749 47.1334 485.912 50.2462 457.458 66.199C457.718 65.8099 422.507 89.8041 404.447 101.477C381.45 116.263 327.79 135.458 327.01 135.717C310.639 142.98 291.02 142.202 274 147.779C260.097 152.319 247.754 159.452 236.061 165.678C239.179 167.104 242.427 168.401 245.675 169.568C276.598 150.373 312.588 142.332 353.645 159.063C354.295 159.322 355.075 159.582 355.724 159.971C355.594 159.841 355.334 159.841 355.205 159.711C404.317 130.4 447.194 123.915 492.668 136.885C492.668 136.885 500.204 139.089 500.464 138.311C501.114 134.68 505.401 119.764 506.701 117.17C512.807 104.201 532.686 100.18 547.628 105.368C547.758 105.108 543.86 98.4939 548.148 90.3229C540.742 112.242 571.275 124.563 584.657 121.45C596.481 126.898 599.469 135.458 614.151 138.311C630.392 137.014 633.64 122.747 627.664 115.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.906 179.037L295.307 162.046C290.63 162.435 286.083 163.214 281.665 164.251C282.185 167.494 283.614 175.276 284.134 178.777C288.811 179.037 293.359 179.167 297.906 179.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.384 175.794C319.734 172.033 318.565 165.807 318.175 162.824C312.848 162.046 307.651 161.657 302.584 161.657L305.183 178.517C310.25 177.999 315.317 177.091 320.384 175.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.112 144.017C469.15 175.274 422.505 201.603 356.242 175.663C356.762 175.923 357.022 175.923 357.022 175.923C330.127 193.432 290.759 196.934 247.492 178.517C238.008 184.224 228.913 190.449 220.078 197.064C192.533 246.349 137.314 276.828 99.7644 340.38C87.811 359.446 79.4956 387.979 81.1847 392C119.383 306.14 193.702 252.704 300.763 231.952C322.591 226.894 322.331 214.573 328.697 214.703C360.27 215.481 383.917 210.682 404.056 201.733C413.8 197.453 421.466 191.616 432.25 188.633C432.38 188.374 432.51 188.114 432.64 187.725C439.656 191.098 447.971 193.043 456.936 193.043C459.795 193.043 462.653 192.784 465.382 192.395L463.563 194.988L389.504 270.084L539.051 184.353C538.661 184.353 500.852 144.406 501.112 144.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.038 166.066C270.49 167.493 265.943 169.179 261.525 171.254C261.655 172.811 261.785 174.886 261.785 175.016C266.723 176.313 271.79 177.35 276.727 177.999C276.207 174.367 275.428 169.049 275.038 166.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.712 164.251C326.102 167.104 326.751 170.995 327.141 173.849C331.429 172.422 335.716 170.736 339.874 168.661C334.937 166.715 330.259 165.289 325.712 164.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19 142.462C432.253 143.11 427.185 144.018 422.248 145.315L426.406 172.552C431.733 171.903 436.8 170.736 441.607 169.309C440.698 163.603 437.709 146.093 437.19 142.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.695 141.294C457.199 141.035 450.832 141.164 444.336 141.683C444.986 145.444 447.194 160.489 448.104 166.974C453.951 164.64 459.537 161.786 464.865 158.414L463.695 141.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.711 141.813L471.231 154.135C475.778 150.892 480.196 147.39 484.613 143.759C480.066 142.851 475.388 142.203 470.711 141.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.188 166.586C373.526 167.364 375.865 168.142 378.204 168.791C378.204 168.661 378.074 165.937 378.074 162.565C375.865 163.862 373.526 165.159 371.188 166.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.129 173.2L415.101 147.261C410.814 148.558 406.396 149.984 402.108 151.67C403.148 157.507 405.227 169.569 405.746 173.071C410.554 173.33 414.971 173.33 419.129 173.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.471 172.034C397.952 168.661 396.522 159.842 395.743 154.135C391.325 156.081 386.908 158.156 382.36 160.49C382.62 162.825 383.4 168.921 383.4 168.921C383.4 168.921 383.01 168.791 382.49 168.791C388.077 170.348 393.404 171.385 398.471 172.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.542 177.48C232.813 176.053 230.345 174.497 228.006 172.811C228.006 172.811 228.006 172.811 228.006 172.941C194.354 149.336 160.833 179.944 121.595 166.845C110.811 163.213 98.9873 155.431 85.9945 153.356C67.9345 150.503 42.9883 158.544 40 174.367C64.5564 151.281 100.676 183.965 134.068 194.989C146.541 199.01 162.002 201.215 172.397 200.048C186.819 198.621 197.863 189.153 211.895 185.651C213.454 185.262 228.915 179.426 235.542 177.48Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 0,
    width: 670.451,
    height: 432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHorse);
export default __webpack_public_path__ + "static/media/footer-horse.690f20a8.svg";
export { ForwardRef as ReactComponent };